var $, previousCreatePlugin, previousGetOrCreatePlugin, previousGetPlugin, previousPlugin,
  hasProp = {}.hasOwnProperty,
  slice = [].slice;

$ = window.jQuery;

previousPlugin = $.plugin;


/*
Factory for creating jQuery plugins.

1. Creates a Class for adding methods that can be called through the plugin.
2. Adds a Bootstrap style `noConflict` method.
3. Creates default options that are automatically overridden.

    $.plugin('toggleSomething', {
      defaults: {foo: 'bar', baz: false},
      init: function() {
        // Called the first time the plugin is called for a particular element.
        console.log(this.element);
        console.log(this.options);
        if (this.options.baz) {
          this.doSomething();
        }
      },
      run: function() {
        // Called everytime the plugin is called (unless a particular method
        // is called)
        console.log('toggle ' + this.element.get(0).tagName);
      },
      doSomething: function() {
        // Internally, the plugin is created as a Class.
        console.log('doSomething!');
      }
    });
    $('body').toggleSomething({baz: true});
    > <body>
    > {foo: 'bar', baz: true}
    > 'doSomething!'
    > 'toggle BODY'
    $('body').toggleSomething();
    > 'toggle BODY'
 */

$.plugin = function(name, methods) {
  var Plugin, dataOptionMapping, defaults, plugin;
  defaults = methods.defaults || {};
  delete methods.defaults;
  dataOptionMapping = methods.dataOptionMapping || {};
  delete methods.dataOptionMapping;
  Plugin = (function() {
    function _Class(element, options) {
      var attr, option, ref, value;
      this.element = element instanceof $ ? element : $(element);
      this.options = $.extend({}, $.fn[name].defaults, typeof options === 'object' && options);
      ref = $.fn[name].dataOptionMapping;
      for (option in ref) {
        if (!hasProp.call(ref, option)) continue;
        attr = ref[option];
        value = this.element.attr(attr);
        if (value != null) {
          this.options[option] = value;
        }
      }
      if (typeof this.init === "function") {
        this.init();
      }
    }

    return _Class;

  })();
  $.extend(Plugin.prototype, methods);
  previousPlugin = $.fn[name];
  plugin = function() {
    var args, method, options;
    options = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    if (typeof options === 'string') {
      method = options;
      options = null;
    } else {
      method = 'run';
    }
    return this.each(function() {
      var element;
      element = $(this);
      plugin = element.getOrCreatePlugin(name, options);
      if (method) {
        return typeof plugin[method] === "function" ? plugin[method].apply(plugin, args) : void 0;
      }
    });
  };
  plugin.Constructor = Plugin;
  plugin.defaults = defaults;
  plugin.dataOptionMapping = dataOptionMapping;
  plugin.noConflict = function() {
    $.fn[name] = previousPlugin;
    return this;
  };
  return $.fn[name] = plugin;
};

$.plugin.noConflict = function() {
  $.plugin = previousPlugin;
  return this;
};

previousGetPlugin = $.fn.getPlugin;

$.fn.getPlugin = function(name) {
  return $(this).data("plugin_" + name);
};

$.fn.getPlugin.noConflict = function() {
  $.fn.getPlugin = previousGetPlugin;
  return this;
};

previousCreatePlugin = $.fn.createPlugin;

$.fn.createPlugin = function() {
  var args, element, instance, name;
  name = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
  element = $(this);
  instance = (function(func, args, ctor) {
    ctor.prototype = func.prototype;
    var child = new ctor, result = func.apply(child, args);
    return Object(result) === result ? result : child;
  })($.fn[name].Constructor, [element].concat(slice.call(args)), function(){});
  element.data("plugin_" + name, instance);
  return instance;
};

$.fn.createPlugin.noConflict = function() {
  $.fn.createPlugin = previousCreatePlugin;
  return this;
};

previousGetOrCreatePlugin = $.fn.getOrCreatePlugin;

$.fn.getOrCreatePlugin = function() {
  var args, element, instance, name;
  name = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
  element = $(this);
  instance = element.getPlugin(name);
  if (instance == null) {
    instance = element.createPlugin.apply(element, [name].concat(slice.call(args)));
  }
  return instance;
};

$.fn.getOrCreatePlugin.noConflict = function() {
  $.fn.getOrCreatePlugin = previousGetOrCreatePlugin;
  return this;
};

module.exports = $.plugin;
